import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  EntityAppletLoginEpService,
  EntityContainerModel,
  Pagination
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
@Component({
  selector: 'app-sales-man-applet-login',
  templateUrl: './sales-man-applet-login.component.html',
  styleUrls: ['./sales-man-applet-login.component.css']
})
export class SalesManAppletLoginComponent implements OnInit, OnDestroy {

  @Input() salesAgent: FormControl;
  @Input() isPurchaser: boolean;

  @Output() salesAgentChange = new EventEmitter<FormControl>();
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<EntityContainerModel[]> = new ReplaySubject<EntityContainerModel[]>(1);
  entityList: EntityContainerModel[];
  fieldLabel: string;
  appletGuid;
  pagination = new Pagination();
  dtoObject = {
    "calcTotalRecords":true,
    "is_employee":true
   
};

  constructor( private entityAppletLoginEpService: EntityAppletLoginEpService ) {}

  ngOnInit() {
    this.appletGuid = sessionStorage.getItem('appletGuid');
    this.fieldLabel = this.isPurchaser? 'Purchaser' : 'Sales Agent';
    
    this.subs.sink = this.entityAppletLoginEpService.getEntityByCriteriaForAppletLoginEp(this.appletGuid,this.dtoObject,this.pagination,this.apiVisa).subscribe(
      {next: resolve => {
        this.entityList = resolve.data;
        this.filteredOptions$.next(this.entityList);
      }});
      
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterCurrency(resolve)});
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_fi_mst_entity_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

